module.exports = __webpack_public_path__ + "img/3.0dcef1a9.png";